import {AlertDescription} from '@chakra-ui/alert';

import {withStylesProvider} from '../../utils/withStylesProvider';

import {AlertActions} from './AlertActions';
import {AlertCloseButton} from './AlertCloseButton';
import {AlertContent} from './AlertContent';
import {AlertIcon} from './AlertIcon';
import {AlertTitle} from './AlertTitle';
import {Alert} from './Alert';
import {StylesProvider} from './context';
import {alertTheme} from './theme/theme';

export {useAlertContext, AlertProvider} from './context';
export type {AlertIconProps} from './AlertIcon';
export type {AlertProps} from './Alert';

type AlertType = typeof Alert & {
  CloseButton: typeof AlertCloseButton;
  Actions: typeof AlertActions;
  Content: typeof AlertContent;
  Icon: typeof AlertIcon;
  Title: typeof AlertTitle;
  Description: typeof AlertDescription;
};

const AlertComponent = withStylesProvider(Alert, StylesProvider, alertTheme) as unknown as AlertType;
AlertComponent.CloseButton = AlertCloseButton;
AlertComponent.Actions = AlertActions;
AlertComponent.Content = AlertContent;
AlertComponent.Icon = AlertIcon;
AlertComponent.Title = AlertTitle;
AlertComponent.Description = AlertDescription;

export {AlertComponent as Alert, AlertCloseButton, AlertActions, AlertContent, AlertIcon, AlertTitle, AlertDescription};
